import React, { type FunctionComponent, type ReactNode, Fragment } from 'react'
import {
  FormFieldError,
  type FormFieldErrorProps,
} from 'legacy/dash-components/forms/form-field/components/FormFieldError'
import { Label, type LabelProps } from 'legacy/dash-components/label/Label'

interface Props extends FormFieldErrorProps, Pick<LabelProps, 'intlId'> {
  name: string
  children: ReactNode
}

export const FormField: FunctionComponent<Props> = ({ name, intlId, children, error }) => (
  <Fragment>
    <Label intlId={intlId} htmlFor={name} />
    {children}
    <FormFieldError error={error} />
  </Fragment>
)
